module.exports = __webpack_public_path__ + "static/media/ctr.edc75291.svg";